import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Observer } from 'rxjs';

@Component({
	selector: 'addiction-checkbox',
	templateUrl: './checkbox.component.html',
	standalone: true,
	imports: [CommonModule, ReactiveFormsModule],
	providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: CheckboxComponent, multi: true }],
})
/** Renderizza dinamicamente una checkbox in due modalità di visualizzazione: check classico o switch */
export class CheckboxComponent implements ControlValueAccessor, OnInit {
	@Input() value?: boolean;
	/** Label da mostrare */
	@Input() label: string = '';
	@Input() disabled = false;
	@Input() readonly = false;

	@Output() valueChange = new EventEmitter<boolean>();

	formControl = new FormControl<boolean>(false);

	constructor() {}

	ngOnInit(): void {
		if (typeof this.value === 'boolean') this.formControl.setValue(this.value);
		if (this.disabled || this.readonly) this.formControl.disable();
		this.formControl.valueChanges.subscribe((value) => {
			this.valueChange.emit(!!value);
		});
	}

	public onTouched: () => void = () => {};

	writeValue(obj: boolean): void {
		this.formControl.setValue(obj);
	}

	registerOnChange(fn: Observer<boolean | null>): void {
		this.formControl.valueChanges.subscribe(fn);
	}

	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	setDisabledState(disabled: boolean): void {
		if (disabled) this.formControl.disable({ emitEvent: false });
		else this.formControl.enable({ emitEvent: false });
	}
}
